<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <polygon id="Path-4" fill-rule="evenodd" points="9 5 9 7 3 7 3 5" />
</svg>